import { render, staticRenderFns } from "./ModalHomeworkStatus.vue?vue&type=template&id=5ff042f9"
import script from "./ModalHomeworkStatus.vue?vue&type=script&lang=js"
export * from "./ModalHomeworkStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports